<template>
  <div class="col-12 col-md-12 col-lg-10">
    <div class="tit text-center">
      <p>Para nos conhecermos melhor, nos informe suas redes socias:</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group">
            <label for="logradouro">Facebook</label>
            <input type="text" class="form-control form-control-lg" v-model="Facebook" placeholder="Ex: www.facebook.com/IouuBrasil/">
          </div>
          <div class="form-group">
            <label for="logradouro">Linkedin</label>
            <input type="text" class="form-control form-control-lg" v-model="Linkedin" placeholder="Ex: www.linkedin.com/company/iouu/">
          </div>
          <div class="text-center fixedOptions">
            <button v-focus class="btn btn-lg btn-primary">Próximo</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
 export default {
   data() {
     const social = this.currentUser.Social
     return {
       Facebook: social ? social.Socio.Facebook: null,
       Linkedin: social ? social.Socio.Linkedin: null,
     }
   },
   props: {
     currentUser: {required: true, type: Object}
   },
   methods: {
     onSubmit(e) {
       e.preventDefault()

        this.currentUser.Social.Socio.Facebook = this.Facebook;
        this.currentUser.Social.Socio.Linkedin = this.Linkedin;

       this.$emit('on-submit', {Social: this.currentUser.Social})
     }
   },
   created() {
    if(!this.currentUser.Social) this.currentUser.Social = {}
   }
 }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/RedesSocaisStep.vue